
/**
 * \@docs-private
 * @param {?} type
 * @return {?}
 */
export function getMdInputUnsupportedTypeError(type: string): Error {
  return Error(`Input type "${type}" isn't supported by mdInput.`);
}
